module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NC-1d008341aae2f50a401a454b3f9eca9b.png";